/* /usr/share/hubspot/build/.hubspot/static-archive/HublyticsTrackerJS/static-3.8/coffee/tracker.coffee */
(function () {
var API_INFO, APP_DOMAIN_MAPPING, BATCH_INTERVAL, EVENT_CLASSES, HAMPLITUDE_STORAGE_KEY, HSTC_CALLBACK_ERROR_TIME, HUBLYTICS_API_URL, HUBLYTICS_USAGE_LOGGING_URL, HublyticsTracker, LIBRARY_INFO, PAGE_VIEW_EVENT, SESSION_LENGTH_IN_MILLISECONDS, STORAGE_KEY_PREFIX, extend, getBaseDomain, getCookie, getValidLocaleString, makeUuid, selectorify,
  slice = [].slice;

EVENT_CLASSES = hublytics.eventClasses;

selectorify = hublytics.selectorify, extend = hublytics.extend, getBaseDomain = hublytics.getBaseDomain, getCookie = hublytics.getCookie, makeUuid = hublytics.makeUuid, getValidLocaleString = hublytics.getValidLocaleString;

HUBLYTICS_API_URL = "hublytics/ingester/event";

HUBLYTICS_USAGE_LOGGING_URL = "usage-logging/v1/log/hublytics-multi/no-auth";

PAGE_VIEW_EVENT = "pageview";

BATCH_INTERVAL = 5000;

HSTC_CALLBACK_ERROR_TIME = 8000;

STORAGE_KEY_PREFIX = "HUBLYTICS_EVENTS_";

HAMPLITUDE_STORAGE_KEY = '__hmpl';

SESSION_LENGTH_IN_MILLISECONDS = 1000 * 60 * 30;

API_INFO = {
  generic: {
    qa: "api.hubapiqa.com",
    prod: "api.hubapi.com"
  },
  hubteam: {
    qa: 'tools.hubteamqa.com',
    prod: 'tools.hubteam.com'
  },
  hubspot: {
    qa: 'app.hubspotqa.com',
    prod: 'app.hubspot.com'
  },
  sidekick: {
    qa: 'api.getsidekickqa.com',
    prod: 'api.getsidekick.com'
  }
};

APP_DOMAIN_MAPPING = {
  "hubteamqa.com": "hubteam",
  "hubteam.com": "hubteam",
  "hubspotqa.com": "hubspot",
  "hubspot.com": "hubspot",
  "getsidekickqa.com": "sidekick",
  "getsidekick.com": "sidekick"
};

LIBRARY_INFO = {
  name: "hublyticstrackerjs",
  version: 2
};

if (window._hsq == null) {
  window._hsq = [];
}

HublyticsTracker = (function() {
  HublyticsTracker.prototype.EVENT_CLASSES = EVENT_CLASSES;

  HublyticsTracker.prototype.eventsLog = [];

  HublyticsTracker.prototype.eventsQueue = [];

  HublyticsTracker.prototype.callbackQueue = [];

  HublyticsTracker.prototype.inBatchPeriod = true;

  HublyticsTracker.prototype.isExternal = false;

  function HublyticsTracker() {
    var appMapping;
    setTimeout((function(_this) {
      return function() {
        _this.inBatchPeriod = false;
        return _this.tryFlush();
      };
    })(this), BATCH_INTERVAL);
    appMapping = APP_DOMAIN_MAPPING[getBaseDomain()];
    if (appMapping) {
      this.apiInfo = API_INFO[appMapping];
    } else {
      this.apiInfo = API_INFO.generic;
      hublytics.log("Hublytics on an unknown domain.");
    }
  }

  HublyticsTracker.prototype.init = function() {
    return this._initialize.apply(this, arguments);
  };

  HublyticsTracker.prototype._initialize = function(opts) {
    if (opts == null) {
      opts = {};
    }
    this.accountId = opts.accountId, this.env = opts.env, this.app = opts.app, this.userIdentifier = opts.userIdentifier, this.teamIdentifier = opts.teamIdentifier, this.email = opts.email, this.isExternal = opts.isExternal, this.batchRequests = opts.batchRequests, this.everyEventProperties = opts.everyEventProperties, this.who_identifier_v2 = opts.who_identifier_v2;
    if (this.batchRequests === false) {
      this.inBatchPeriod = false;
    }
    if (this.everyEventProperties) {
      this.everyEventProperties = this.flattenData(this.everyEventProperties);
    }
    if (opts.isExternal != null) {
      this.isExternal = opts.isExternal;
    }
    if (this.env == null) {
      this.env = "prod";
    }
    if (this.isExternal) {
      this.hstcCallback();
    }
    this.eventsQueue = this.eventsQueue.concat(this.getSavedEvents());
    if (this._validateInitialization()) {
      return hublytics.log("Initialized w/ accountId: " + this.accountId + ", app: " + this.app);
    }
  };

  HublyticsTracker.prototype._validateInitialization = function() {
    var consoleGroup, errors;
    errors = [];
    if (!this.isExternal && (!this.who_identifier_v2 && !this.email)) {
      hublytics.error("Apps that are not external (isExternal=false) need an email or who_identifier_v2 passed in to init() in order to create the who_identifier_v2.");
    }
    if (errors.length) {
      if (console.group) {
        consoleGroup = "HublyticsTrackerJS Initialization Errors";
        console.group(consoleGroup);
        hublytics.log(data);
        errors.forEach(function(err) {
          return hublytics.error(err);
        });
        if (typeof console.groupEnd === "function") {
          console.groupEnd(consoleGroup);
        }
      } else {
        errors.forEach(function(err) {
          return hublytics.error(err);
        });
      }
      return false;
    }
    return true;
  };

  HublyticsTracker.prototype._getHamplitudeValues = function() {
    var currentTime, stored;
    stored = hublytics.getStorage(HAMPLITUDE_STORAGE_KEY);
    if (!stored) {
      this.hamplitudeValues = {
        device_id: makeUuid(),
        last_event_id: 0,
        last_sequence_number: 0,
        last_timestamp_checked_against_session: Date.now(),
        session_id: Date.now()
      };
      hublytics.setStorage(HAMPLITUDE_STORAGE_KEY, this.hamplitudeValues);
    } else {
      this.hamplitudeValues = stored;
    }
    currentTime = Date.now();
    if (currentTime - this.hamplitudeValues.last_timestamp_checked_against_session > SESSION_LENGTH_IN_MILLISECONDS) {
      this._updateHamplitudeValues({
        last_event_id: 0,
        session_id: currentTime
      });
    }
    return this.hamplitudeValues;
  };

  HublyticsTracker.prototype._updateHamplitudeValues = function(updateObj) {
    this.hamplitudeValues = extend({}, this.hamplitudeValues, updateObj);
    hublytics.setStorage(HAMPLITUDE_STORAGE_KEY, this.hamplitudeValues);
    return this.hamplitudeValues;
  };

  HublyticsTracker.prototype.hstcCallback = function() {
    var HSTC_ERROR_EVENT;
    window._hsq.push((function(_this) {
      return function() {
        return _this.tryFlush();
      };
    })(this));
    HSTC_ERROR_EVENT = "hstc-not-set";
    return setTimeout((function(_this) {
      return function() {
        var event;
        if (!window._hstc_ran) {
          hublytics.error("_hstc_ran=false after " + HSTC_CALLBACK_ERROR_TIME + "ms, will try to send " + HSTC_ERROR_EVENT + " event to hublytics. It may get set after the timeout in which case events in the queue will get flushed and sent properly. See https://git.hubteam.com/pages/HubSpot/HublyticsDocs/ready_to_code/js/debugging.html.");
          event = {
            hublytics_account_id: _this.accountId,
            where_app: _this.app,
            where_screen: _this.screen || "hstc-error",
            where_subscreen: _this.subscreen,
            who_identifier: _this.userIdentifier,
            who_team_identifier: _this.teamIdentifier,
            who_email: _this.email,
            what_event: HSTC_ERROR_EVENT,
            what_event_class: EVENT_CLASSES.ERROR,
            when_timestamp: Date.now(),
            library: LIBRARY_INFO
          };
          return _this.actualFlush([event]);
        }
      };
    })(this), HSTC_CALLBACK_ERROR_TIME);
  };

  HublyticsTracker.prototype.trackAppScreen = function(app, screen, subscreen, data, opts) {
    if (data == null) {
      data = {};
    }
    if (opts == null) {
      opts = {};
    }
    this.app = app;
    this.screen = screen;
    this.subscreen = subscreen;
    return this.trackView(data, opts);
  };

  HublyticsTracker.prototype.trackScreen = function(screen, subscreen, data, opts) {
    if (data == null) {
      data = {};
    }
    if (opts == null) {
      opts = {};
    }
    this.screen = screen;
    this.subscreen = subscreen;
    return this.trackView(data, opts);
  };

  HublyticsTracker.prototype.trackSubscreen = function(subscreen, data, opts) {
    if (data == null) {
      data = {};
    }
    if (opts == null) {
      opts = {};
    }
    this.subscreen = subscreen;
    return this.trackView(data, opts);
  };

  HublyticsTracker.prototype.trackView = function(data, opts) {
    if (data == null) {
      data = {};
    }
    if (opts == null) {
      opts = {};
    }
    return this.track(extend({
      what_event: PAGE_VIEW_EVENT,
      what_event_class: EVENT_CLASSES.VIEW
    }, data), opts);
  };

  HublyticsTracker.prototype.trackBulk = function(events) {
    events.forEach((function(_this) {
      return function(e) {
        var opts;
        opts = _.extend({}, e.opts || {}, {
          enqueueOnly: true
        });
        return _this.track(e.event, opts);
      };
    })(this));
    return this.tryFlush();
  };

  HublyticsTracker.prototype.trackCreation = function() {
    return this.trackEventWithClass.apply(this, [EVENT_CLASSES.CREATION].concat(slice.call(arguments)));
  };

  HublyticsTracker.prototype.trackInteraction = function() {
    return this.trackEventWithClass.apply(this, [EVENT_CLASSES.INTERACTION].concat(slice.call(arguments)));
  };

  HublyticsTracker.prototype.trackActivation = function() {
    return this.trackEventWithClass.apply(this, [EVENT_CLASSES.ACTIVATION].concat(slice.call(arguments)));
  };

  HublyticsTracker.prototype.trackSignup = function() {
    return this.trackEventWithClass.apply(this, [EVENT_CLASSES.SIGNUP].concat(slice.call(arguments)));
  };

  HublyticsTracker.prototype.trackExposure = function() {
    return this.trackEventWithClass.apply(this, [EVENT_CLASSES.EXPOSURE].concat(slice.call(arguments)));
  };

  HublyticsTracker.prototype.trackUsage = function() {
    return this.trackEventWithClass.apply(this, [EVENT_CLASSES.USAGE].concat(slice.call(arguments)));
  };

  HublyticsTracker.prototype.trackWarning = function() {
    return this.trackEventWithClass.apply(this, [EVENT_CLASSES.WARNING].concat(slice.call(arguments)));
  };

  HublyticsTracker.prototype.trackError = function() {
    return this.trackEventWithClass.apply(this, [EVENT_CLASSES.ERROR].concat(slice.call(arguments)));
  };

  HublyticsTracker.prototype.trackEventWithClass = function(eventClass, event, data, opts) {
    var what;
    if (data == null) {
      data = {};
    }
    if (opts == null) {
      opts = {};
    }
    what = extend({}, data.what, {
      event: event,
      event_class: eventClass
    });
    data = extend({}, data, {
      what: what
    });
    return this.track(data, opts);
  };

  HublyticsTracker.prototype.clearSubscreen = function() {
    return delete this.subscreen;
  };

  HublyticsTracker.prototype.flattenData = function(data) {
    var flatData, i, j, key, len, len1, ref, ref1, topKey, topObject;
    flatData = {};
    ref = Object.keys(data);
    for (i = 0, len = ref.length; i < len; i++) {
      topKey = ref[i];
      if (topKey === 'what' || topKey === 'who' || topKey === 'where' || topKey === 'how') {
        topObject = data[topKey];
        ref1 = Object.keys(topObject);
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          key = ref1[j];
          flatData[topKey + "_" + key] = topObject[key];
        }
      } else {
        flatData[topKey] = data[topKey];
      }
    }
    return flatData;
  };

  HublyticsTracker.prototype.track = function(data, opts) {
    if (data == null) {
      data = {};
    }
    if (opts == null) {
      opts = {};
    }
    return this._track(data, opts);
  };

  HublyticsTracker.prototype._track = function(data, opts) {
    var baseWhatExtraJson, hamplitudeObject, i, j, key, len, len1, overridableWhereProperties, prop, ref, whereAppOverride;
    if (data == null) {
      data = {};
    }
    if (opts == null) {
      opts = {};
    }
    data = this.flattenData(data);
    if (this.everyEventProperties) {
      ref = Object.keys(this.everyEventProperties);
      for (i = 0, len = ref.length; i < len; i++) {
        key = ref[i];
        if (typeof this.everyEventProperties[key] === 'object') {
          data[key] = extend({}, data[key], this.everyEventProperties[key]);
        } else {
          data[key] = this.everyEventProperties[key];
        }
      }
    }
    if (opts.element && !data['what_dom']) {
      data['what_dom'] = selectorify(opts.element);
    }
    whereAppOverride = data['where_app_override'];
    if (whereAppOverride && (!data['what_variation'])) {
      data['what_variation'] = this.app;
    }
    try {
      delete data['where_app_override'];
    } catch (undefined) {}
    if (this.env === 'qa' && whereAppOverride) {
      hublytics.log("where_app was overridden using where_app_override for event \"" + data['what_event'] + "\"");
    }
    baseWhatExtraJson = {
      screenWidth: screen.width,
      screenHeight: screen.height,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    };
    hamplitudeObject = this._getNextHamplitudeValuesAndUpdateStorage();
    data = extend({}, {
      hublytics_account_id: this.accountId,
      where_app: whereAppOverride || this.app,
      where_screen: this.screen,
      where_subscreen: this.subscreen,
      who_identifier_v2: this.who_identifier_v2 || "[NOT YET SET, SHOULD GET SET PRIOR TO FLUSH]",
      who_team_identifier: this.teamIdentifier,
      when_timestamp: Date.now(),
      library: LIBRARY_INFO
    }, hamplitudeObject, data);
    if (data.what_extra_json && typeof data.what_extra_json === "string") {
      data.what_extra_json = JSON.parse(data.what_extra_json);
    }
    data.what_extra_json = extend({}, baseWhatExtraJson, data.what_extra_json);
    data = this.transformData(data);
    if (this._validateEvent(data)) {
      if (opts.persistWhereOptions !== false) {
        overridableWhereProperties = ['app', 'screen', 'subscreen', 'subscreen2'];
        for (j = 0, len1 = overridableWhereProperties.length; j < len1; j++) {
          prop = overridableWhereProperties[j];
          if (prop === 'app' && whereAppOverride) {
            continue;
          }
          this[prop] = data["where_" + prop];
        }
      }
      return this.considerSending(data, opts);
    }
  };

  HublyticsTracker.prototype._getNextHamplitudeValuesAndUpdateStorage = function() {
    var currentHamplitudeValues, thisHamplitudeObject, this_event_id, this_sequence_number;
    currentHamplitudeValues = this._getHamplitudeValues();
    this_event_id = currentHamplitudeValues.last_event_id + 1;
    this_sequence_number = currentHamplitudeValues.last_sequence_number + 1;
    this._updateHamplitudeValues({
      last_event_id: this_event_id,
      last_sequence_number: this_sequence_number,
      last_timestamp_checked_against_session: Date.now()
    });
    return thisHamplitudeObject = {
      device_id: currentHamplitudeValues.device_id,
      event_id: this_event_id,
      session_id: currentHamplitudeValues.session_id,
      sequence_number: this_sequence_number,
      language: hublytics.getValidLocaleString()
    };
  };

  HublyticsTracker.prototype.transformData = function(data) {
    var what_extra_json;
    what_extra_json = data.what_extra_json;
    data.what_extra_json = JSON.stringify(what_extra_json);
    return data;
  };

  HublyticsTracker.prototype._validateEvent = function(data) {
    var consoleGroup, errors;
    errors = [];
    if (data.hublytics_account_id == null) {
      errors.push("Missing property: hublyticsAccountId. Did you call init()?");
    }
    if (data.where_app == null) {
      errors.push("Missing property: where.app/where_app Did you call init()?");
    }
    if (data.where_screen == null) {
      errors.push("Missing property: where.screen/where_screen. Did you call trackScreen()?");
    }
    if (data.what_event_class == null) {
      errors.push("Missing property: what.event_class/what_event_class.");
    }
    if (!this.isExternal) {
      if (data.who_team_identifier == null) {
        errors.push("Missing property: who.teamIdentifier/who_team_identifier");
      }
    }
    if (errors.length) {
      if (console.group) {
        consoleGroup = "HublyticsTrackerJS Errors";
        console.group(consoleGroup);
        hublytics.log(data);
        errors.forEach(function(err) {
          return hublytics.error(err);
        });
        if (typeof console.groupEnd === "function") {
          console.groupEnd(consoleGroup);
        }
      } else {
        errors.forEach(function(err) {
          return hublytics.error(err);
        });
      }
      return false;
    }
    return true;
  };

  HublyticsTracker.prototype.considerSending = function(data, opts) {
    if (opts == null) {
      opts = {};
    }
    this.eventsQueue.push(data);
    this.saveEvent(data);
    if (opts.callback) {
      this.callbackQueue.push(opts.callback);
    }
    if (!opts.enqueueOnly) {
      return this.tryFlush();
    }
  };

  HublyticsTracker.prototype.setWhoIdentifierV2 = function() {
    var HSTC_COOKIE_KEY, event, hstcCookie, i, identifierFromCookie, len, ref, results;
    if (!this.who_identifier_v2) {
      if (this.isExternal) {
        HSTC_COOKIE_KEY = "__hstc";
        hstcCookie = getCookie(HSTC_COOKIE_KEY);
        if (hstcCookie) {
          identifierFromCookie = hstcCookie.split('.')[1];
          this.who_identifier_v2 = "VISITOR:::" + identifierFromCookie + ":::" + this.accountId;
        } else {
          hublytics.error("Couldn't find " + HSTC_COOKIE_KEY + " cookie even though _hstc_ran=true");
          this.immediatelyTrackHublyticsError("hstc-cookie-not-found");
        }
      } else {
        this.who_identifier_v2 = "EMAIL:::" + this.email + ":::" + this.accountId;
      }
    }
    if (this.who_identifier_v2) {
      ref = this.eventsQueue;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        event = ref[i];
        results.push(event.who_identifier_v2 = this.who_identifier_v2);
      }
      return results;
    }
  };

  HublyticsTracker.prototype.immediatelyTrackHublyticsError = function(eventName) {
    var event;
    event = {
      hublytics_account_id: this.accountId,
      where_app: this.app,
      where_screen: this.screen || "hstc-cookie-error",
      where_subscreen: this.subscreen,
      who_identifier: this.userIdentifier,
      who_team_identifier: this.teamIdentifier,
      who_email: this.email,
      what_event: eventName,
      what_event_class: EVENT_CLASSES.ERROR,
      when_timestamp: Date.now(),
      library: LIBRARY_INFO
    };
    return this.actualFlush([event]);
  };

  HublyticsTracker.prototype.canFlush = function() {
    return !this.inBatchPeriod && (!this.isExternal || (this.isExternal && window._hstc_ran));
  };

  HublyticsTracker.prototype.tryFlush = function() {
    if (this.canFlush()) {
      if (this.eventsQueue.length) {
        this.setWhoIdentifierV2();
        this.actualFlush(this.eventsQueue, this.callbackQueue);
        this.eventsQueue = [];
        return this.callbackQueue = [];
      }
    }
  };

  HublyticsTracker.prototype.actualFlush = function(events, callbacks) {
    var event, i, len, request;
    if (callbacks == null) {
      callbacks = [];
    }
    hublytics.log("Sending events:");
    for (i = 0, len = events.length; i < len; i++) {
      event = events[i];
      hublytics.log(event);
    }
    request = new XMLHttpRequest();
    request.open("POST", this.getTrackingURL(), true);
    request.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
    request.onreadystatechange = (function(_this) {
      return function() {
        var callback, j, len1, results;
        if (request.readyState === 4) {
          if (request.status >= 200 && request.status < 300) {
            _this.clearSavedEvents();
          }
          results = [];
          for (j = 0, len1 = callbacks.length; j < len1; j++) {
            callback = callbacks[j];
            results.push(callback());
          }
          return results;
        }
      };
    })(this);
    request.send(JSON.stringify(events));
    return this.eventsLog = this.eventsLog.concat(events);
  };

  HublyticsTracker.prototype.saveEvent = function(event) {
    var events;
    events = this.getSavedEvents();
    events.push(event);
    return hublytics.setStorage(this.getEventsStorageKey(), events);
  };

  HublyticsTracker.prototype.clearSavedEvents = function() {
    return hublytics.clearStorage(this.getEventsStorageKey());
  };

  HublyticsTracker.prototype.getSavedEvents = function() {
    return hublytics.getStorage(this.getEventsStorageKey()) || [];
  };

  HublyticsTracker.prototype.getEventsStorageKey = function() {
    return STORAGE_KEY_PREFIX + this.accountId;
  };

  HublyticsTracker.prototype.getTrackingURL = function() {
    var domain, queryString;
    queryString = "?clientSendTimestamp=" + (Date.now());
    domain = this.apiInfo[this.env];
    if (domain) {
      return "https://" + domain + "/" + HUBLYTICS_USAGE_LOGGING_URL + queryString;
    } else {
      return hublytics.error("Unknown env: " + this.env);
    }
  };

  HublyticsTracker.prototype.printEventsLog = function() {
    var group;
    group = "All hublytics events during this session";
    console.group(group);
    console.log("--- As a table ---");
    console.table(this.eventsLog);
    console.log('--- As an array ---');
    console.log(this.eventsLog);
    return console.groupEnd(group);
  };

  HublyticsTracker.prototype.printState = function() {
    var group, i, len, prop, stateVars;
    stateVars = ['app', 'screen', 'subscreen', 'subscreen2', 'accountId', 'env', 'userIdentifier', 'teamIdentifier', 'email', 'isExternal'];
    group = "State of the HublyticsTracker";
    console.group(group);
    for (i = 0, len = stateVars.length; i < len; i++) {
      prop = stateVars[i];
      hublytics.log(prop + ": " + this[prop]);
    }
    return console.groupEnd(group);
  };

  return HublyticsTracker;

})();

window.HublyticsTracker = new HublyticsTracker;

if (typeof hubspot !== 'undefined' && hubspot.define) {
  hubspot.define('hubspot.HublyticsTrackerJS.tracker', ['hubspot.HublyticsTrackerJS.utils'], function(utils) {
    return window.HublyticsTracker;
  });
}
}());




//////////////////
// WEBPACK FOOTER
// ../~/bender-webpack/lib/legacy-modules/module-manifest-dependency-loader.js!../~/bender-webpack/lib/no-parse-loader.js!../~/bender-webpack/lib/sporks/loader.js!/usr/share/hubspot/build/.hubspot/static-archive/HublyticsTrackerJS/static-3.8/coffee/tracker.coffee
// module id = 592
// module chunks = 